export default __webpack_public_path__ + "static/media/golf-cart-eps.5d149a7b.png";